import * as React           from "react";

import {
    faBan,
    faBrush,
    faCaretDown,
    faCaretUp,
    faPencil,
    faShoppingCart,
    faSquareCheck,
    IconDefinition,
}                        from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {cx}              from "emotion";

import {AnyAction}                    from "@Common/react/any-action";
import {
    ComponentLink,
    makeChain,
    valueHelper as value,
}                                     from "@Common/react/cst2";
import {UseState}                     from "@Common/react/use-state";
import {Types}                        from "@Common/types";
import {Dropdown}                     from "@Common/ui-components/dropdown/dropdown";
import {ItemAction}                   from "./item-actions";

export const DesktopActions = ({actions, footer}:{
    actions : ItemAction[],
    footer ?: React.ReactNode,
}) => (
    makeChain<JSX.Element>()
    .then("disabledState", ({}, next:ComponentLink<typeof UseState<boolean>>) => (
        UseState({next, initValue: false})
    ))
    .then("runAction", value(({disabledState: {onChange: setDisabled}}) => (
        (action:ItemAction) => {
            setDisabled(true, async () => {
                await action.run();
                setDisabled(false);
            });
        }
    )))
    .then(({disabledState: {value: disabled}, runAction}) => {
        const defaultAction   = actions.find(action => action.name === "default");
        const linkLabel       = defaultAction?.label ?? "Place/Edit";
        const dropdownActions = actions.filter(action => action.name !== "checkout");
        const shouldDropdown  = !defaultAction || dropdownActions.length > 1;
        return Dropdown({
            renderToggle: ({domRef, showExpand, showingExpand}) => (
                <a
                    className={cx("edit", {disabled})}
                    xd-qa-type="link"
                    xd-qa-name={linkLabel}
                    ref={domRef}
                    onClick={() => !disabled && (shouldDropdown ? showExpand(true) : (defaultAction && runAction(defaultAction)))}
                >
                    {linkLabel}
                    {shouldDropdown && <i><FontAwesomeIcon icon={showingExpand ? faCaretUp : faCaretDown}/></i>}
                </a>
            ),
            renderExpand: ({close, domRef, position}) => (
                <div
                    className="dropdown"
                    style={position}
                    ref={domRef}
                >
                    <AnyAction action={close}/>
                    {dropdownActions.map(action => (
                        <a
                            key={action.name}
                            className="dropdown-item"
                            xd-qa-type="dropdown_item"
                            xd-qa-name={action.label}
                            onClick={() => runAction(action)}
                        >
                            <i className="icon">{action.icon && <FontAwesomeIcon icon={action.icon}/>}</i>
                            {action.label}
                        </a>
                    ))}
                    {footer && (
                        <div className="dropdown-footer">{footer}</div>
                    )}
                </div>
            ),
        })
    })
    .run()
);